import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../api/axios-instance';
import { ApkFileMetadataDto } from '../../dtos/apk-file-metadata.dto';
import { APK_FILE_UPLOAD_STATUS } from '../../enums/apk-file-upload-status.enum';
import { createPathParams } from '../create-path-params/create-path-params.util';
import { Endpoints } from '../endpoints-file.utils';

export const getChunkUploadStatus = async (
  id: number,
  onSuccess: () => void,
  onError: () => void,
  maxRetryNumber: number = 10
): Promise<AxiosResponse<ApkFileMetadataDto>> =>
  new Promise<AxiosResponse<ApkFileMetadataDto>>((resolve, reject) => {
    let retryCount = 0;
    const intervalId = setInterval(() => {
      axiosInstance
        .get<ApkFileMetadataDto>(
          createPathParams<'id'>(Endpoints.FILE_METADATA_PATH, { id })
        )
        .then(response => {
          if (
            response.data.apkProcessedState ===
              APK_FILE_UPLOAD_STATUS.PROCESSED ||
            response.data.apkProcessedState ===
              APK_FILE_UPLOAD_STATUS.NOT_PROCESSED
          ) {
            clearInterval(intervalId);
            const messageFn =
              response.data.apkProcessedState ===
              APK_FILE_UPLOAD_STATUS.PROCESSED
                ? onSuccess
                : onError;
            messageFn();
            resolve(response);
            return;
          }
          retryCount++;
          if (retryCount === maxRetryNumber) {
            clearInterval(intervalId);
            onError();
            reject('Max retry surpassed!');
            return;
          }
        })
        .catch(err => reject(err));
    }, 2000);
  });
